import { claimTaskGroup } from "../../../Services/Requests";
import { useNotificationStore } from "../../../Store/NotificationStore";

// Определим интерфейс для награды
interface Reward {
  amount: number;
  type: string;
  new_balance?: number;
}

// Определим интерфейс для ответа API при получении награды
interface ClaimTaskGroupResponse {
  success?: boolean;
  message?: string;
  rewards_processed?: Reward[];
  status?: string;
  task_id?: number;
  data?: {
    rewards?: Reward[];
    amount?: number;
    type?: string;
  };
}

// Определим интерфейс для объекта ошибки
interface ApiError {
  message: string;
  code?: number;
  details?: any;
}

// Определим тип для колбэков
type SuccessCallback = (response: ClaimTaskGroupResponse) => void;
type ErrorCallback = (error: ApiError) => void;

export class QuestsService {
  static async claimQuestReward(
    groupId: number,
    onSuccess: SuccessCallback,
    onError: ErrorCallback
  ): Promise<void> {
    // Получаем функцию setNotification из store
    const setNotification = useNotificationStore.getState().setNotification;

    try {
      console.log(
        `🚀 QuestsService.claimQuestReward - start for groupId: ${groupId}`
      );

      // Вызываем функцию claimTaskGroup из Requests.js
      claimTaskGroup(
        groupId,
        (response: ClaimTaskGroupResponse) => {
          console.log(
            `✅ Reward for quest ${groupId} claimed successfully:`,
            response
          );

          let rewards: Reward[] = [];

          if (
            response.rewards_processed &&
            Array.isArray(response.rewards_processed)
          ) {
            rewards = response.rewards_processed;
          } else if (
            response.data?.rewards &&
            Array.isArray(response.data.rewards)
          ) {
            rewards = response.data.rewards;
          } else if (
            response.data?.amount !== undefined &&
            response.data?.type
          ) {
            rewards = [
              { amount: response.data.amount, type: response.data.type },
            ];
          }

          if (rewards.length === 0) {
            console.warn(
              "Не удалось получить информацию о наградах из ответа:",
              response
            );
          }

          setNotification({
            type: "Success",
            message: "Награда за квест получена!",
            rewards: rewards,
          });

          onSuccess(response);
        },
        (error: ApiError) => {
          console.error(`❌ QuestsService.claimQuestReward - error:`, error);

          // Показываем сообщение об ошибке
          setNotification({
            type: "Error",
            message: "Квест на проверке. Повтори через 30 секунд.",
          });

          onError(error);
        }
      );
    } catch (error) {
      console.error(
        `❌ QuestsService.claimQuestReward - unexpected error`,
        error
      );

      // Показываем сообщение о неожиданной ошибке
      setNotification({
        type: "Error",
        message: "Ошибка при получении награды",
      });

      onError({ message: "Ошибка при получении награды" });
    }
  }
}
